// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2cf995b7","455":"82ff1b2a","977":"52fd06c6"}[chunkId] + ".chunk.js";
};